import React from 'react';

import { Global, css } from '@emotion/react';

const fonts = [
  ['Graphik-Bold-Cy-Web', 'woff2', 'Graphik', 700],
  ['Graphik-Light-Cy-Web', 'woff2', 'Graphik', 300],
  ['Graphik-Medium-Cy-Web', 'woff2', 'Graphik', 500],
  ['Graphik-Regular-Cy-Web', 'woff2', 'Graphik', 400],
];

const fontUrlBase = 'https://cdn-cashy-static-assets.lucidchart.com/fonts/graphik/';

// loop through fonts and build the CSS to declare each one.
const declareFontsCss = fonts.reduce((string, [name, type, family, weight]) => {
  return `${string}
  @font-face {
    font-family: '${family}';
    src: url('${fontUrlBase}${name}.${type}') format('${type}');
    font-weight: ${weight};
    font-display: auto;
  }`;
}, '');

const GlobalCSS = () => (
  <Global
    styles={css([
      {
        'html, body, input, textarea, button': {
          fontFamily: 'Graphik, -apple-system, BlinkMacSystemFont, "Segoe UI", "Helvetica Neue", Arial, sans-serif',
        },
        'html, body': {
          margin: 0,
          padding: 0,
        },
        'ul, ol': {
          padding: 0,
          marginLeft: '20px',
        },
        '*, *::before, *::after': {
          boxSizing: 'border-box',
        },
        img: {
          maxWidth: '100%',
        },
        fieldset: {
          border: 'none',
        },
        '.osano-cm-widget': {
          display: 'none',
        },
      },
      declareFontsCss,
    ])}
  />
);

export default GlobalCSS;
